module.exports = __webpack_public_path__ + "static/media/2.70e1a68e.jpg";